(function () {
  // Mobiles Menue: Panel von rechts, mit Abdunklung, Escape und Sperre des
  // Hintergrund-Scrollens. Am Desktop liegt die Navigation normal im Header.
  const burger = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-nav]");
  const scrim = document.querySelector("[data-nav-scrim]");
  const navClose = document.querySelector("[data-menu-close]");
  if (burger && nav) {
    const setNav = function (open) {
      nav.classList.toggle("is-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("nav-open", open);
      if (scrim) {
        if (open) {
          scrim.hidden = false;
          // ein Frame warten, sonst gibt es keinen Übergang zum Einblenden
          requestAnimationFrame(function () { scrim.classList.add("is-on"); });
        } else {
          scrim.classList.remove("is-on");
          setTimeout(function () { if (!nav.classList.contains("is-open")) scrim.hidden = true; }, 520);
        }
      }
      if (open && navClose) navClose.focus();
      else if (!open) burger.focus();
    };

    burger.addEventListener("click", function () { setNav(!nav.classList.contains("is-open")); });
    if (navClose) navClose.addEventListener("click", function () { setNav(false); });
    if (scrim) scrim.addEventListener("click", function () { setNav(false); });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.classList.contains("is-open")) setNav(false);
    });
    // beim Wechsel auf Desktop-Breite aufräumen
    window.addEventListener("resize", function () {
      if (window.innerWidth > 820 && nav.classList.contains("is-open")) setNav(false);
    });
  }

  const policies = document.querySelector("[data-policies]");
  const policiesToggle = policies && policies.querySelector("[data-policies-toggle]");
  if (policies && policiesToggle) {
    const setOpen = function (open) {
      policies.classList.toggle("is-open", open);
      policiesToggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    policiesToggle.addEventListener("click", function (event) {
      event.stopPropagation();
      setOpen(!policies.classList.contains("is-open"));
    });

    document.addEventListener("click", function (event) {
      if (!policies.contains(event.target)) setOpen(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && policies.classList.contains("is-open")) {
        setOpen(false);
        policiesToggle.focus();
      }
    });
  }

  const revealTargets = document.querySelectorAll("[data-reveal]");
  if (revealTargets.length) {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const supported = "IntersectionObserver" in window;

    if (!supported || reduced || !document.documentElement.classList.contains("js-anim")) {
      revealTargets.forEach(function (el) { el.classList.add("is-revealed"); });
    } else {
      const stagger = parseInt(document.documentElement.dataset.revealStagger || "70", 10);

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const el = entry.target;

          // elements that share a parent come in one after another
          const siblings = Array.prototype.filter.call(
            el.parentElement ? el.parentElement.children : [],
            function (node) { return node.hasAttribute("data-reveal"); }
          );
          const index = Math.max(0, siblings.indexOf(el));
          el.style.transitionDelay = Math.min(index, 8) * stagger + "ms";

          el.classList.add("is-revealed");
          observer.unobserve(el);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });

      revealTargets.forEach(function (el) { observer.observe(el); });
    }
  }

  // Hero-Slideshow: langsames Ueberblenden, Pfeile, Punkte, optionaler
  // Selbstlauf. Der Selbstlauf haelt an, solange jemand mit der Maus oder der
  // Tastatur im Hero ist, ruht in Hintergrund-Tabs und laeuft gar nicht erst
  // fuer Besucher, die weniger Bewegung wuenschen.
  document.querySelectorAll("[data-hero]").forEach(function (hero) {
    const slides = hero.querySelectorAll("[data-hero-slide]");
    if (slides.length < 2) return;
    const dots = hero.querySelectorAll("[data-hero-dot]");
    const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let interval = parseInt(hero.dataset.heroAutoplay, 10) || 0;
    if (calm) interval = 0;
    let current = 0;
    let timer = null;
    let held = false;
    let armed = false; // Selbstlauf erst nach der ersten Interaktion

    // Slides 2+ tragen ihre Bildadressen nur in data-Attributen (siehe
    // hero.liquid). Sie bekommen sie, sobald das erste Bild geladen ist --
    // oder sofort, falls jemand vorher weiterklickt.
    let woken = false;
    const wake = function () {
      if (woken) return;
      woken = true;
      hero.querySelectorAll("source[data-srcset]").forEach(function (source) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute("data-srcset");
      });
      hero.querySelectorAll("img[data-hero-deferred]").forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute("data-srcset");
        img.removeAttribute("data-src");
        img.removeAttribute("data-hero-deferred");
      });
    };
    const firstImg = slides[0].querySelector("img");
    if (!firstImg || firstImg.complete) {
      window.setTimeout(wake, 300);
    } else {
      firstImg.addEventListener("load", function () { window.setTimeout(wake, 300); }, { once: true });
      firstImg.addEventListener("error", wake, { once: true });
    }

    const show = function (next) {
      wake();
      current = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle("is-active", i === current); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === current);
        dot.setAttribute("aria-selected", i === current ? "true" : "false");
      });
    };

    const stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    const start = function () {
      stop();
      if (!interval || held || document.hidden || !armed) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    };

    hero.querySelectorAll("[data-hero-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        show(current + (parseInt(button.dataset.heroStep, 10) || 1));
        start();
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(parseInt(dot.dataset.heroDot, 10) || 0);
        start();
      });
    });

    ["mouseenter", "focusin"].forEach(function (type) {
      hero.addEventListener(type, function () { held = true; stop(); });
    });
    ["mouseleave", "focusout"].forEach(function (type) {
      hero.addEventListener(type, function () { held = false; start(); });
    });
    document.addEventListener("visibilitychange", start);

    // Der Selbstlauf beginnt erst, wenn jemand die Seite wirklich benutzt
    // (scrollt, tippt, die Maus bewegt). Wer nur schaut, sieht in Ruhe das
    // erste Bild -- und Messwerkzeuge warten nicht mehr auf den ersten
    // Wechsel, bevor sie die Seite fuer fertig halten.
    const arm = function () {
      if (armed) return;
      armed = true;
      ["scroll", "pointermove", "pointerdown", "keydown", "touchstart"].forEach(function (type) {
        window.removeEventListener(type, arm, true);
      });
      wake();
      start();
    };
    ["scroll", "pointermove", "pointerdown", "keydown", "touchstart"].forEach(function (type) {
      window.addEventListener(type, arm, { capture: true, passive: true });
    });
  });

  // Produktkacheln: Hover zeigt das zweite Foto, die Pfeile blaettern weiter,
  // auf dem Handy wird gewischt. Als Funktion, damit spaeter nachgeladene
  // Kacheln (zuletzt angesehen) dieselbe Behandlung bekommen.
  const initCardGalleries = function (root) {
    root.querySelectorAll("[data-card-gallery]").forEach(function (gallery) {
      if (gallery.dataset.cardReady) return;
      gallery.dataset.cardReady = "1";
      const images = gallery.querySelectorAll("[data-card-image]");
      if (images.length < 2) return;

      let index = 0;
      let woken = false;

      // Die Bilder 2 bis 4 tragen ihre Adresse nur in data-src. Erst wenn die
      // Kachel angefasst wird, bekommen sie ein src.
      const wake = function () {
        if (woken) return;
        woken = true;
        images.forEach(function (image) {
          if (!image.dataset.src) return;
          if (image.dataset.sizes) image.sizes = image.dataset.sizes;
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          delete image.dataset.src;
        });
      };

      const show = function (next) {
        wake();
        index = (next + images.length) % images.length;
        images.forEach(function (image, i) { image.classList.toggle("is-active", i === index); });
      };

      gallery.addEventListener("mouseenter", function () { show(1); });
      gallery.addEventListener("mouseleave", function () { show(0); });
      gallery.addEventListener("focusin", wake);

      [["[data-card-prev]", -1], ["[data-card-next]", 1]].forEach(function (pair) {
        const button = gallery.querySelector(pair[0]);
        if (!button) return;
        button.addEventListener("click", function (event) {
          // die Kachel ist ein Link -- beim Pfeil nie der Seite folgen
          event.preventDefault();
          event.stopPropagation();
          show(index + pair[1]);
        });
      });

      // Wischen: waagerecht deutlich mehr als senkrecht, sonst scrollt die Seite.
      let startX = null;
      let startY = null;
      let swiped = false;
      gallery.addEventListener("touchstart", function (event) {
        wake();
        const t = event.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        swiped = false;
      }, { passive: true });
      gallery.addEventListener("touchend", function (event) {
        if (startX === null) return;
        const t = event.changedTouches[0];
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          swiped = true;
          // Wischen loest meist gar keinen Klick aus -- die Sperre darf also
          // nicht auf den naechsten echten Tipp warten.
          setTimeout(function () { swiped = false; }, 400);
          show(index + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      // Nach einem Wisch nicht versehentlich die Produktseite oeffnen.
      gallery.addEventListener("click", function (event) {
        if (!swiped) return;
        swiped = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    });
  };
  initCardGalleries(document);

  // Collection filters: submit on change, and behave like a normal form without JS.
  const facetForm = document.querySelector("[data-facets]");
  if (facetForm) {
    const fallback = facetForm.querySelector("[data-facet-fallback]");
    if (fallback) fallback.hidden = true;

    let priceTimer = null;
    facetForm.addEventListener("change", function (event) {
      if (event.target.type === "number") return; // handled on input, debounced
      facetForm.submit();
    });

    facetForm.addEventListener("input", function (event) {
      if (event.target.type !== "number") return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { facetForm.submit(); }, 700);
    });

    // only one dropdown open at a time, and click outside closes it
    const facets = facetForm.querySelectorAll("[data-facet]");
    facets.forEach(function (facet) {
      facet.addEventListener("toggle", function () {
        if (!facet.open) return;
        facets.forEach(function (other) { if (other !== facet) other.open = false; });
      });
    });

    document.addEventListener("click", function (event) {
      if (facetForm.contains(event.target)) return;
      facets.forEach(function (facet) { facet.open = false; });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") facets.forEach(function (facet) { facet.open = false; });
    });
  }

  // Product page gallery: thumbnails, arrows, keyboard.
  const gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    const slides = gallery.querySelectorAll("[data-gallery-slide]");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    const counter = gallery.querySelector("[data-gallery-index]");

    if (slides.length > 1) {
      let current = 0;

      const stop = function (slide) {
        // HTML5-Video anhalten; bei YouTube/Vimeo stoppt das Neusetzen der
        // Quelle die Wiedergabe, sonst läuft der Ton im Hintergrund weiter.
        const video = slide.querySelector("video");
        if (video && !video.paused) video.pause();
        const frame = slide.querySelector("iframe");
        if (frame && frame.src) frame.src = frame.src;
      };

      const show = function (next) {
        const leaving = slides[current];
        current = (next + slides.length) % slides.length;
        if (leaving && slides[current] !== leaving) stop(leaving);
        slides.forEach(function (slide, i) { slide.classList.toggle("is-active", i === current); });
        thumbs.forEach(function (thumb, i) {
          const active = i === current;
          thumb.classList.toggle("is-active", active);
          thumb.setAttribute("aria-current", active ? "true" : "false");
          if (active && thumb.scrollIntoView) {
            thumb.scrollIntoView({ block: "nearest", inline: "nearest" });
          }
        });
        if (counter) counter.textContent = current + 1;
      };

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(parseInt(thumb.dataset.galleryThumb, 10) || 0);
        });
      });

      const prev = gallery.querySelector("[data-gallery-prev]");
      const next = gallery.querySelector("[data-gallery-next]");
      if (prev) prev.addEventListener("click", function () { show(current - 1); });
      if (next) next.addEventListener("click", function () { show(current + 1); });

      gallery.addEventListener("keydown", function (event) {
        if (event.key === "ArrowLeft") { event.preventDefault(); show(current - 1); }
        if (event.key === "ArrowRight") { event.preventDefault(); show(current + 1); }
      });

      // Die Thumbnail-Leiste scrollt ohne Balken. Die beiden Pfeile zeigen
      // sich nur, solange es in ihrer Richtung noch etwas zu sehen gibt.
      const strip = gallery.querySelector("[data-thumbs]");
      const steppers = gallery.querySelectorAll("[data-thumbs-step]");
      if (strip && steppers.length) {
        const vertical = function () { return strip.scrollHeight - strip.clientHeight > 2; };
        const paint = function () {
          const down = vertical();
          const pos = down ? strip.scrollTop : strip.scrollLeft;
          const span = down
            ? strip.scrollHeight - strip.clientHeight
            : strip.scrollWidth - strip.clientWidth;
          steppers.forEach(function (button) {
            const back = parseInt(button.dataset.thumbsStep, 10) < 0;
            button.hidden = span <= 2 || (back ? pos <= 2 : pos >= span - 2);
          });
        };

        steppers.forEach(function (button) {
          button.addEventListener("click", function () {
            const dir = parseInt(button.dataset.thumbsStep, 10) || 1;
            const first = strip.firstElementChild;
            const step = first ? first.getBoundingClientRect().height + 8 : 100;
            if (vertical()) strip.scrollTop += dir * step * 2;
            else strip.scrollLeft += dir * step * 2;
          });
        });

        strip.addEventListener("scroll", paint);
        window.addEventListener("resize", paint);
        if (window.ResizeObserver) new ResizeObserver(paint).observe(strip);
        paint();
      }
    }
  }

  // ---------------------------------------------------------------------
  // "My rare pieces" — Merkliste.
  //
  // Der Speicher steckt bewusst hinter einer kleinen Schnittstelle. Wer später
  // auf eine Shopify-App umsteigt, ersetzt nur die vier Methoden darin; Herzen,
  // Zähler und Merklistenseite bleiben unverändert.
  // ---------------------------------------------------------------------
  const Wishlist = (function () {
    const KEY = "srp:wishlist";
    let memory = [];

    const read = function () {
      try {
        const raw = window.localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return memory; // privater Modus o. ä.: dann eben nur für diesen Besuch
      }
    };
    const write = function (list) {
      memory = list;
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent("wishlist:change", { detail: list }));
    };

    return {
      all: read,
      has: function (handle) { return read().indexOf(handle) !== -1; },
      toggle: function (handle) {
        const list = read();
        const i = list.indexOf(handle);
        if (i === -1) list.push(handle); else list.splice(i, 1);
        write(list);
        return i === -1;
      },
      remove: function (handle) {
        const list = read().filter(function (h) { return h !== handle; });
        write(list);
      }
    };
  })();

  const paintHearts = function () {
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      const on = Wishlist.has(btn.dataset.wishlistToggle);
      btn.classList.toggle("is-on", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      const n = Wishlist.all().length;
      el.textContent = n;
      el.hidden = n === 0;
    });
  };

  document.addEventListener("click", function (event) {
    const btn = event.target.closest && event.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    Wishlist.toggle(btn.dataset.wishlistToggle);
    btn.classList.add("is-pulsing");
    setTimeout(function () { btn.classList.remove("is-pulsing"); }, 600);
  });

  document.addEventListener("wishlist:change", paintHearts);
  paintHearts();

  // Merklistenseite: Produkte frisch aus Shopify nachladen, damit Preis und
  // Verfügbarkeit stimmen, statt beim Merken eingefrorene Daten zu zeigen.
  const page = document.querySelector("[data-wishlist-page]");
  if (page) {
    const grid = page.querySelector("[data-wishlist-grid]");
    const empty = page.querySelector("[data-wishlist-empty]");

    const money = function (cents, product) {
      if (product && product.price_formatted) return product.price_formatted;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR"
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };

    const render = function () {
      const handles = Wishlist.all();
      if (!handles.length) {
        grid.hidden = true;
        grid.innerHTML = "";
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      grid.hidden = false;

      Promise.all(handles.map(function (handle) {
        return fetch("/products/" + handle + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (items) {
        const html = [];
        items.forEach(function (product, i) {
          if (!product) {
            Wishlist.remove(handles[i]); // Produkt gibt es nicht mehr
            return;
          }
          const sized = function (url, w) {
            return url.replace(/(\.[a-z]+)(\?|$)/i, "_" + w + "x$1$2");
          };
          const image = product.featured_image
            ? sized(product.featured_image, 600)
            : "";
          html.push(
            '<article class="card">' +
              '<div class="card__visual">' +
                '<a href="' + product.url + '" class="card__media">' +
                  (image
                    ? '<img class="card__img is-active" src="' + image +
                      '" srcset="' + sized(product.featured_image, 300) + ' 300w, ' +
                      sized(product.featured_image, 450) + ' 450w, ' +
                      sized(product.featured_image, 600) + ' 600w" ' +
                      'sizes="(max-width: 700px) 46vw, (max-width: 1100px) 30vw, 250px" ' +
                      'alt="" width="600" height="600" loading="lazy" decoding="async">'
                    : "") +
                '</a>' +
                '<button class="heart heart--card is-on" type="button" data-wishlist-toggle="' + product.handle + '" aria-pressed="true" aria-label="Remove from My rare pieces">' +
                  '<svg width="19" height="17" viewBox="0 0 19 17" fill="none" aria-hidden="true"><path d="M9.5 15.6S1.6 11.2 1.6 6.1a4 4 0 0 1 7.9-1.2 4 4 0 0 1 7.9 1.2c0 5.1-7.9 9.5-7.9 9.5z" stroke="currentColor" stroke-width="1.35" stroke-linejoin="round"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="card__meta">' +
                '<div>' +
                  '<a class="card__title" href="' + product.url + '">' + product.title + '</a>' +
                  (product.vendor ? '<div class="card__origin">' + product.vendor + '</div>' : "") +
                '</div>' +
                '<div class="card__price">' + money(product.price, product) + '</div>' +
              '</div>' +
            '</article>'
          );
        });
        grid.innerHTML = html.join("");
        if (!html.length) { grid.hidden = true; empty.hidden = false; }
        paintHearts();
      });
    };

    document.addEventListener("wishlist:change", render);
    render();
  }

  // ---------------------------------------------------------------------
  // Zuletzt angesehen. Merkt sich die Handles im Browser; die Kacheln kommen
  // ueber /products/<handle>?view=card fertig gerendert aus Shopify.
  // ---------------------------------------------------------------------
  (function () {
    const KEY = "srp:recent";
    const MAX = 12;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const read = function () {
      try { return JSON.parse(window.localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
    };
    const write = function (list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    };

    const productSection = document.querySelector("[data-product-handle]");
    const current = productSection ? productSection.dataset.productHandle : null;

    document.querySelectorAll("[data-recently-viewed]").forEach(function (section) {
      const grid = section.querySelector("[data-recently-grid]");
      const limit = parseInt(section.dataset.limit, 10) || 4;
      const handles = read().filter(function (h) { return h !== current; }).slice(0, limit);
      if (!handles.length || !grid) return;

      Promise.all(handles.map(function (handle) {
        return fetch(root + "products/" + encodeURIComponent(handle) + "?view=card")
          .then(function (r) { return r.ok ? r.text() : ""; })
          .catch(function () { return ""; });
      })).then(function (parts) {
        const html = parts.filter(function (p) { return p.indexOf("card") !== -1; }).join("");
        if (!html) return;
        grid.innerHTML = html;
        // nachgeladene Kacheln sind schon im Bild -- nicht erst einblenden
        grid.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-revealed"); });
        initCardGalleries(grid);
        paintHearts();
        section.hidden = false;
      });
    });

    // erst nach dem Anzeigen merken, damit das aktuelle Stueck nicht in
    // seiner eigenen Liste auftaucht
    if (current) {
      const list = read().filter(function (h) { return h !== current; });
      list.unshift(current);
      write(list);
    }
  })();

  // Mitlaufende Kaufleiste auf dem Handy: sichtbar, sobald der echte
  // Kaufknopf nach oben aus dem Bild gescrollt ist. Der Knopf in der Leiste
  // haengt ueber das Attribut "form" am selben Formular, es gibt also keinen
  // zweiten Weg in den Warenkorb, der auseinanderlaufen koennte.
  const buybar = document.querySelector("[data-buybar]");
  const atc = document.querySelector("[data-atc]");
  if (buybar && atc && "IntersectionObserver" in window) {
    const setBar = function (on) {
      buybar.classList.toggle("is-on", on);
      document.body.classList.toggle("has-buybar", on);
    };
    const barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // nur nach oben hinausgescrollt, nicht wenn der Knopf noch kommt
        setBar(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    barObserver.observe(atc);
  }

  // Nach oben: erscheint, sobald man rund anderthalb Bildschirme gescrollt hat.
  const toTop = document.querySelector("[data-to-top]");
  if (toTop) {
    let ticking = false;
    const update = function () {
      ticking = false;
      toTop.classList.toggle("is-on", window.scrollY > window.innerHeight * 1.5);
    };
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
    toTop.addEventListener("click", function () {
      const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: 0, behavior: still ? "auto" : "smooth" });
      const skip = document.getElementById("MainContent");
      if (skip) { skip.setAttribute("tabindex", "-1"); skip.focus({ preventScroll: true }); }
    });
  }

  // Teilen: Link kopieren mit kurzer Rückmeldung
  document.querySelectorAll("[data-share-copy]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const url = btn.dataset.shareCopy || window.location.href;
      const done = btn.querySelector("[data-share-done]");
      const show = function () {
        if (!done) return;
        done.hidden = false;
        btn.classList.add("is-copied");
        setTimeout(function () { done.hidden = true; btn.classList.remove("is-copied"); }, 1800);
      };
      // Der alte Weg über ein Hilfsfeld. Er funktioniert auch dort, wo die
      // Zwischenablage gesperrt ist — etwa in der Vorschau des Theme-Editors,
      // die in einem iframe läuft.
      const legacy = function () {
        const tmp = document.createElement("textarea");
        tmp.value = url;
        tmp.setAttribute("readonly", "");
        tmp.style.position = "fixed";
        tmp.style.top = "-1000px";
        document.body.appendChild(tmp);
        tmp.select();
        tmp.setSelectionRange(0, url.length);
        try { document.execCommand("copy"); } catch (e) {}
        document.body.removeChild(tmp);
        show();
      };

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          const p = navigator.clipboard.writeText(url);
          if (p && p.then) p.then(show, legacy);
          else show();
        } else {
          legacy();
        }
      } catch (e) {
        legacy();
      }
    });
  });
})();
